import { APP_PDC_URL } from "../../config";
import { createHttpHeaderWithAuthorization } from "../services/http-header";

import { callWithRetry } from "../services/callWithRetry";

export const documentPreviewConstants = {
  GET_PREVIEW_DOCUMENT_DETAIL_START: "GET_PREVIEW_DOCUMENT_DETAIL_START",
  GET_PREVIEW_DOCUMENT_DETAIL_SUCCESS: "GET_PREVIEW_DOCUMENT_DETAIL_SUCCESS",
  GET_PREVIEW_DOCUMENT_DETAIL_ERROR: "GET_PREVIEW_DOCUMENT_DETAIL_ERROR",

  GET_PREVIEW_DOCUMENT_START: "GET_PREVIEW_DOCUMENT_START",
  GET_PREVIEW_DOCUMENT_SUCCESS: "GET_PREVIEW_DOCUMENT_SUCCESS",
  GET_PREVIEW_DOCUMENT_ERROR: "GET_PREVIEW_DOCUMENT_ERROR"
};

export function loadDocumentPreview(
  auth, accountantSelected, accountantIdSelected, companySelected, clientIdSelected, idAttachment, page
) {
  let request = {
    method: "get",
    url: APP_PDC_URL + `/v2/documents/${idAttachment}/preview/${page || 1}?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}`,
    headers: createHttpHeaderWithAuthorization(auth?.loginAuth?.securityToken)
  };

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: documentPreviewConstants.GET_PREVIEW_DOCUMENT_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((res) => {
          if (res.status === 200) {
            dispatch({
              type: documentPreviewConstants.GET_PREVIEW_DOCUMENT_SUCCESS,
              payload: {
                content: res.data.content,
                documentId: idAttachment
              }
            });
          } else {
            dispatch({
              type: documentPreviewConstants.GET_PREVIEW_DOCUMENT_ERROR,
              error: res
            });
          }
        })
        .catch((response) => {
          dispatch({
            type: documentPreviewConstants.GET_PREVIEW_DOCUMENT_ERROR,
            error: response
          });
        });
    });
  };
}

export function loadDocumentDetail(
  auth, accountantSelected, accountantIdSelected, companySelected, clientIdSelected, idAttachment
) {
  let request = {
    method: "get",
    url: APP_PDC_URL + `/v2/documents/${idAttachment}?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}`,
    headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
  };

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: documentPreviewConstants.GET_PREVIEW_DOCUMENT_DETAIL_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((res) => {
          if (res.status === 200) {
            dispatch({
              type: documentPreviewConstants.GET_PREVIEW_DOCUMENT_DETAIL_SUCCESS,
              payload: res.data
            });
          } else {
            dispatch({
              type: documentPreviewConstants.GET_PREVIEW_DOCUMENT_DETAIL_ERROR,
              error: res
            });
          }
        })
        .catch((response) => {
          dispatch({
            type: documentPreviewConstants.GET_PREVIEW_DOCUMENT_DETAIL_ERROR,
            error: response
          });
        });
    });
  };
}
